import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import { ReactSVG } from 'react-svg';
import { Skeleton } from '../ui/skeleton';
interface BaseSVGProps {
  src: string;
  width: number;
  height: number;
  className?: string;
}
function BaseSVG(t0) {
  const $ = _c(13);
  const {
    src,
    width,
    height,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] !== height || $[3] !== width) {
    t2 = () => <Skeleton className={`w-[${width}px] h-[${height}px]`} />;
    t3 = () => <Skeleton className={`w-[${width}px] h-[${height}px]`} />;
    t4 = svg => {
      svg.setAttribute("style", `width: ${width}px; height: ${height}px;`);
    };
    $[2] = height;
    $[3] = width;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== src || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <ReactSVG className={t1} src={src} fallback={t2} loading={t3} beforeInjection={t4} />;
    $[7] = src;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export default BaseSVG;